import useCollectionGoals from './useCollectionGoals';
import { useCollectionProgress } from '../collectionProgress';
import { getCardsRatingSum } from '../utils';
import { ECollectionBannerState, EOwnedCollectionStatus, } from '../types';
import useCollectionState from './useCollectionState';
var useProgressBar = function (collectionId) {
    var _a, _b, _c, _d, _e, _f;
    var goals = useCollectionGoals(collectionId);
    var progress = useCollectionProgress(collectionId);
    var collectionState = useCollectionState(collectionId);
    var value = 0;
    if (((_a = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _a === void 0 ? void 0 : _a.status) === EOwnedCollectionStatus.COMPLETED &&
        ((_b = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _b === void 0 ? void 0 : _b.finalValue)) {
        value = (_c = progress === null || progress === void 0 ? void 0 : progress.progress) === null || _c === void 0 ? void 0 : _c.finalValue;
    }
    else if (progress) {
        value = getCardsRatingSum(progress);
    }
    return {
        value: value,
        target: ((_d = goals === null || goals === void 0 ? void 0 : goals.reachTargetValue) === null || _d === void 0 ? void 0 : _d.isRequired)
            ? goals.reachTargetValue.targetValue
            : 0,
        maxTarget: ((_e = goals === null || goals === void 0 ? void 0 : goals.reachTargetValue) === null || _e === void 0 ? void 0 : _e.isRequired)
            ? goals.reachTargetValue.targetValueMax
            : 0,
        isUpcoming: collectionState === null ||
            collectionState === ECollectionBannerState.UPCOMING,
        dialogHeader: (_f = progress === null || progress === void 0 ? void 0 : progress.collection) === null || _f === void 0 ? void 0 : _f.headline,
    };
};
export default useProgressBar;
